module.exports = __webpack_public_path__ + "img/banner2.da48b16e.png";